export default __webpack_public_path__ + "static/media/shape-linear.3dbba6b1.PNG";